// extracted by mini-css-extract-plugin
module.exports = {"background":"Popup--background--3--FE","background_logo":"Popup--background_logo--1TJdS","heading":"Popup--heading--3OaiQ","paragraph":"Popup--paragraph--lNAGu"};